"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.DialogMain = exports.Main = exports.DialogContent = exports.Dialog = void 0;

var _isNan = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/number/is-nan"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var childPanelCss = function childPanelCss(_ref) {
  var isCompact = _ref.isCompact,
      groupOffsetY = _ref.groupOffsetY,
      offsetY = _ref.offsetY;
  var totalOffset = isCompact ? 48 : 64;
  var childBottomOffsetY = totalOffset + groupOffsetY + offsetY;
  return (0, _styledComponents.css)(["border-bottom-left-radius:", ";border-top-left-radius:", ";height:calc(100% - ", "px);margin-top:", ";"], _tokens["default"].spaceSm, _tokens["default"].spaceSm, childBottomOffsetY, isCompact ? "".concat(_stylers["default"].spacer(3)) : "".concat(_stylers["default"].spacer(4)));
};

function slideIn(slideInTransform, slideOutTransform) {
  return (0, _styledComponents.keyframes)(["from{transform:", ";}to{transform:", ";}"], slideOutTransform, slideInTransform);
}

function slideOut(slideInTransform, slideOutTransform) {
  return (0, _styledComponents.keyframes)(["from{transform:", ";}to{transform:", ";}"], slideInTransform, slideOutTransform);
}

var compactStyles = (0, _styledComponents.css)(["padding:", ";"], _stylers["default"].spacer(2));

var Dialog = _styledComponents["default"].div.withConfig({
  displayName: "Dialogstyles__Dialog",
  componentId: "aynya2-0"
})(function (_ref2) {
  var width = _ref2.width,
      isAnimating = _ref2.isAnimating,
      isSlideFromLeft = _ref2.isSlideFromLeft,
      isOpen = _ref2.isOpen,
      hasPushedElement = _ref2.hasPushedElement,
      kind = _ref2.kind,
      offsetY = _ref2.offsetY,
      zIndex = _ref2.zIndex,
      isInline = _ref2.isInline;
  var widthAsPx = (0, _isNan["default"])(Number(width)) ? width : "".concat(width, "px");
  var slideOutTransform = isSlideFromLeft ? "translateX(-100%)" : "translateX(100%)";
  var slideInTransform = "translateX(0)";
  var animationStyle = isAnimating ? (0, _styledComponents.css)(["animation:", " 0.4s forwards;"], isOpen ? slideIn(slideInTransform, slideOutTransform) : slideOut(slideInTransform, slideOutTransform)) : "";
  var childPanel = kind === "child" ? childPanelCss : "";
  var boxShadow = hasPushedElement ? "none" : _tokens["default"].modal.shadow;
  return (0, _styledComponents.css)(["", ";background:", ";border:0;box-shadow:", ";box-sizing:border-box;", " display:flex;flex-direction:column;height:100%;", " ", " margin:0;overflow:auto;padding:0;", " right:0;top:0;top:", "px;width:", ";z-index:", ";&:focus{outline:0;}"], animationStyle, _tokens["default"].color.white, boxShadow, childPanel, offsetY ? "height: calc(100% - ".concat(offsetY, "px);") : "", isSlideFromLeft ? "left: 0;" : "right: 0;", isInline ? "position: relative;" : "position: fixed;", offsetY, widthAsPx, zIndex);
});

exports.Dialog = Dialog;

var DialogContent = _styledComponents["default"].div.withConfig({
  displayName: "Dialogstyles__DialogContent",
  componentId: "aynya2-1"
})(function (_ref3) {
  var hasPushedElement = _ref3.hasPushedElement,
      isSlideFromLeft = _ref3.isSlideFromLeft,
      isCompact = _ref3.isCompact,
      kind = _ref3.kind;
  return (0, _styledComponents.css)(["flex-grow:1;margin:0;padding:0;&:focus{", ";}", " ", " ", ";"], _stylers["default"].focusRing.subtle(true), hasPushedElement && isSlideFromLeft ? "border-right: 1px solid ".concat(_tokens["default"].border.color) : "", hasPushedElement && !isSlideFromLeft ? "border-left: 1px solid ".concat(_tokens["default"].border.color) : "", isCompact || kind === "child" ? compactStyles : "");
});

exports.DialogContent = DialogContent;

var Main = _styledComponents["default"].div.withConfig({
  displayName: "Dialogstyles__Main",
  componentId: "aynya2-2"
})(["display:flex;flex-direction:column;height:100%;position:relative;width:100%;"]);

exports.Main = Main;

var DialogMain = _styledComponents["default"].div.withConfig({
  displayName: "Dialogstyles__DialogMain",
  componentId: "aynya2-3"
})(["flex-grow:1;overflow-y:auto;"]);

exports.DialogMain = DialogMain;
//# sourceMappingURL=Dialog.styles.js.map